// extracted by mini-css-extract-plugin
export default {"headContainer":"header_headContainer__5RRtP","head":"header_head__GrsDm","accentText":"header_accentText__v3vuE"};